import type { PortalPaso } from "../components/Proyectos/PortalSolicitanteTrazabilidad";

export type PortalSubtabDef = {
  id: string;
  label: string;
  pasoIds: string[];
};

export type PortalPestanaDef = {
  id: string;
  label: string;
  subtabs: PortalSubtabDef[];
};

export type PortalSubtabVm = {
  id: string;
  label: string;
  pasoIds?: string[];
  pasos: PortalPaso[];
};

export type PortalPestanaVm = {
  id: string;
  label: string;
  estado_pestana: string;
  subtabs: PortalSubtabVm[];
  visible?: boolean;
};

/** Misma lógica de etapas que la gestión interna del proyecto. */
export const PORTAL_PESTANAS_TRAMITE: PortalPestanaDef[] = [
  {
    id: "solicitud",
    label: "Solicitud del servicio",
    subtabs: [
      {
        id: "revision",
        label: "Revisión de solicitud",
        pasoIds: ["correccion_datos_solicitud", "solicitud_aprobada_hito"],
      },
      {
        id: "factibilidad",
        label: "Documentación de solicitud",
        pasoIds: ["factibilidad_documentos"],
      },
    ],
  },
  {
    id: "diseno",
    label: "Diseño",
    subtabs: [
      {
        id: "gestion_documental",
        label: "Gestión documental",
        pasoIds: ["gestion_documental", "gestion_documental_aprobada_hito"],
      },
      {
        id: "documentos",
        label: "Plano y presupuesto",
        pasoIds: ["diseno_documentos"],
      },
      {
        id: "liquidacion",
        label: "Liquidación",
        pasoIds: ["liquidacion_diseno"],
      },
    ],
  },
  {
    id: "supervision",
    label: "Supervisión y aprobación",
    subtabs: [
      {
        id: "supervision",
        label: "Revisión de supervisión",
        pasoIds: ["supervision_correccion"],
      },
      {
        id: "carta",
        label: "Carta remisoria y comprobante",
        pasoIds: ["carta_remisoria"],
      },
      {
        id: "retie",
        label: "RETIE",
        pasoIds: ["retie_documentos"],
      },
      {
        id: "grandes_clientes",
        label: "Grandes clientes",
        pasoIds: [
          "gc_revision_solicitud",
          "gc_correccion_solicitud",
          "gc_documentos_solicitante",
          "gc_aprobacion_provisional",
        ],
      },
    ],
  },
];

export function agruparPasosEnPestanas(
  pasos: PortalPaso[],
  pestanasDef: PortalPestanaDef[] = PORTAL_PESTANAS_TRAMITE,
): PortalPestanaVm[] {
  const porId = new Map(pasos.map((p) => [p.id, p]));
  return pestanasDef
    .map((pestana) => {
      const subtabs = pestana.subtabs
        .map((st) => {
          const pasosSub = st.pasoIds.map((id) => porId.get(id)).filter(Boolean) as PortalPaso[];
          return { ...st, pasos: pasosSub };
        })
        .filter((st) => st.pasos.length > 0);
      const estadoPestana = (() => {
        const todos = subtabs.flatMap((s) => s.pasos);
        if (todos.some((p) => p.estado_paso === "activo")) return "activo";
        if (todos.length && todos.every((p) => p.estado_paso === "completado")) return "completado";
        if (todos.some((p) => p.estado_paso === "en_espera_revision")) return "en_espera_revision";
        return "pendiente";
      })();
      return { ...pestana, subtabs, estado_pestana: estadoPestana, visible: subtabs.length > 0 };
    })
    .filter((p) => p.visible);
}

export function indicePestanaActiva(pestanas: PortalPestanaVm[]) {
  const i = pestanas.findIndex((p) => p.estado_pestana === "activo");
  return i >= 0 ? i : 0;
}

export function indiceSubtabActiva(subtabs: { pasos: PortalPaso[] }[]) {
  const i = subtabs.findIndex((st) => st.pasos.some((p) => p.estado_paso === "activo"));
  return i >= 0 ? i : 0;
}
